import { render, staticRenderFns } from "./ComposeMenu.vue?vue&type=template&id=5eb40ff2&"
import script from "./ComposeMenu.vue?vue&type=script&lang=js&"
export * from "./ComposeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports